import { isResourceOfType } from '@opallabs/api/v2'
import { useWorkspace } from '@opallabs/hooks'
import { type FieldMenuOption } from '@opallabs/satellite'
import { CustomFieldsRequestParams, RawCustomFieldsResponse } from '../types'
import { useReadCustomFields } from '../useReadCustomFields'

export const selectCustomFieldMap = (
  responseDocument: RawCustomFieldsResponse
) => {
  const options = responseDocument.included?.filter(
    isResourceOfType('custom_field_option', 'V3')
  )
  const colors = responseDocument.included?.filter(
    isResourceOfType('custom_field_color', 'V3')
  )

  if (!options) {
    return {}
  }

  return options.reduce<Record<string, FieldMenuOption>>((acc, option) => {
    acc[option.id] = {
      value: option.id,
      label: option.attributes.display_name,
      position: option.attributes.position,
      color:
        colors?.find(
          (color) =>
            color.id === option.relationships.custom_field_color?.data?.id
        )?.attributes.color ?? null,
    }

    return acc
  }, {})
}

export const useCustomFieldOptionMap = () => {
  const { uuid } = useWorkspace()
  const params: CustomFieldsRequestParams = {
    query: {
      filter: { workspace_id: [uuid] },
      include: [
        'custom_field_type',
        'active_options.custom_field_color',
        'deleted_options.custom_field_color',
      ],
      page: {
        limit: 500, // Increased from default 150
      },
    },
  }
  return useReadCustomFields({ params, select: selectCustomFieldMap })
}
